module.exports = __webpack_public_path__ + "a2257ea09717e2a7626a5ca4d8b01d78.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/trash-can.svg
// module id = 126
// module chunks = 0